import * as Sentry from '@sentry/browser';
import { GET_INSTANCE_WAIT_DURATION } from './constants.js';
import { storage } from '../storage/storageWrapper.js';

let initResolve;
let initReject;
const initialiser = new Promise((resolve, reject) => {
    initResolve = resolve;
    initReject = reject;
});
const KEY = 'eu1-89229be06fa54243ab7413dd164af3a3';
class MParticleError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MParticleError';
    }
}
const mParticleEventType = {
    Unknown: 0,
    Navigation: 1,
    Location: 2,
    Search: 3,
    Transaction: 4,
    UserContent: 5,
    UserPreference: 6,
    Social: 7,
    Other: 8,
    Media: 9,
};
const mParticleInit = async (mParticle, options, userIdentities) => {
    const knownErrors = [
        'Data plan version was not found',
        'Error sending event to mParticle servers',
        'Error parsing JSON response from Identity server',
    ];
    try {
        await fetch('https://jssdkcdns.mparticle.com', {
            mode: 'no-cors',
        });
    }
    catch {
        return initReject();
    }
    const config = {
        logger: {
            error: (message) => {
                const isKnownError = knownErrors.some((error) => message.includes(error));
                if (!isKnownError) {
                    Sentry.captureException(new MParticleError(message));
                }
            },
            verbose: console.log,
            warning: console.warn,
        },
        dataPlan: {
            planId: 'mparticle_web',
        },
        identifyRequest: { userIdentities },
        ...options,
    };
    mParticle.init(KEY, config);
    initResolve(mParticle);
};
const mParticleGetInstance = async () => {
    const initialisedInstance = new Promise((resolve) => {
        const timeout = setTimeout(() => resolve(null), GET_INSTANCE_WAIT_DURATION);
        initialiser
            .then((mParticleInstance) => {
            mParticleInstance.ready(() => {
                resolve(mParticleInstance);
            });
        })
            .catch(() => {
            resolve(null);
        })
            .finally(() => {
            clearTimeout(timeout);
        });
    });
    return initialisedInstance;
};
const mParticleLogEvent = async (eventName, eventType, attributes) => {
    const mParticle = await mParticleGetInstance();
    if (mParticle) {
        mParticle.logEvent(eventName, eventType, attributes);
    }
};
const mParticleLogPageView = async (eventName, attributes) => {
    const mParticle = await mParticleGetInstance();
    if (mParticle) {
        mParticle.logPageView(eventName, attributes);
    }
};
const mParticleLogin = async (data) => {
    const mParticle = await mParticleGetInstance();
    if (mParticle) {
        mParticle.Identity.login(data);
    }
};
const mParticleLogout = async () => {
    const mParticle = await mParticleGetInstance();
    if (mParticle) {
        mParticle.Identity.logout({});
    }
};
const mParticleTrackSessionAttributes = async (countryCode, utmParameters) => {
    const mParticle = await mParticleGetInstance();
    if (!mParticle) {
        return;
    }
    const sessionId = mParticle.sessionManager.getSession();
    const sessionIdFromLocalStorage = storage.local.getItem('sessionId');
    if (sessionIdFromLocalStorage && sessionIdFromLocalStorage === sessionId) {
        return;
    }
    if (!sessionIdFromLocalStorage || sessionIdFromLocalStorage !== sessionId) {
        storage.local.setItem('sessionId', sessionId);
        mParticleLogEvent('session_start_info', mParticle.EventType.Other, {
            country: countryCode,
            platform: 'web',
            url: window.location.href,
            query_parameters: window.location.search,
            referrer: document.referrer,
            url_path: window.location.pathname,
            ...utmParameters,
        });
    }
};

export { mParticleEventType, mParticleGetInstance, mParticleInit, mParticleLogEvent, mParticleLogPageView, mParticleLogin, mParticleLogout, mParticleTrackSessionAttributes };
//# sourceMappingURL=mParticle.js.map
